import {
  Avatar,
  Flex,
  Image,
  Progress,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
  ProgressBar,
  Box,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  Button,
  PopoverBody,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useEffect, useRef } from "react";
import { useGetState } from "../../context/useGetState";
import { photoBaseURL } from "../../service/api";
import Fancybox from "../dashboard/discover/stories/Fancybox";
import { useState } from "react";
import { BiCaretDown } from "react-icons/bi";
import { IoCaretDownOutline } from "react-icons/io5";
import "./ChatFeed.css"
import { successNotifier } from "../..";
import DeleteGroupMessageModal from "./DeleteGroupMessageModal";
import { deleteGroupMessage } from "./service";
import Microlink from '@microlink/react'


let utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

function convertToTimeAgo(message_date) {
  // Parse the ISO 8601 date string to a Date object
  const createdAtDate = new Date(message_date);

  // Format the date to "4:38 am" format using dayjs
  const formattedTime = dayjs(createdAtDate).format("h:mm A");

  return formattedTime;
}

//check if string is url
function checkSTring(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    var _string=pattern.test(str)
    console.log('str test-->',_string)
  // return !!pattern.test(str);
  return _string? <Microlink url={str}    style={{ width: '300px' }}/>:str
}
export const ChatFeed = ({ chat, userId, currentGroupChat, setImgPreview, imgPreview, receiverCurrentChat, incomingLastMessage, 
  setIsServerImageLoaded, isServerImageLoaded, progressBar, setProgressBar }) => {
  const { state } = useGetState();
  const authUserId = userId
  // if (progressBar) {
  // console.log('progressBar: ', progressBar?.groupId);
  console.log('chat: ', chat);
  console.log('authUserId: ', authUserId);
  // }
  if (chat?.sender?.id === authUserId) {
    console.log('true:', true);
  } else {
    console.log('true:', false);
  }

  const [deleteGroupMessageModalOpen, setDeleteGroupMessageModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const fromUserBg = useColorModeValue("#fff", "#3B4959");
  const toUserBg = useColorModeValue("#AFBBC6", "#243C50");

  const fromUserStyle = {
    color: "#7B8793",
    bg: fromUserBg,
    borderTopLeftRadius: " 8px",
    borderTopRightRadius: " 8px",
    borderBottomRightRadius: "8px",
  };
  const toUserStyle = {
    color: "#fff",
    bg: toUserBg,
    borderTopLeftRadius: " 8px",
    borderBottomRightRadius: "8px",
    borderBottomLeftRadius: "8px",
  };

  const caretPosition = {
    right: 0,
    top: 0
  };

  const ref = useRef(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ behaviour: "smooth" });
  }, [chat?.message]);

  const handleGroupMessageDelete = (selectedChat, selectedGroupData) => {
    try {
      const res = deleteGroupMessage(selectedChat?.id);
      setLoading(false);
      successNotifier(`Successfully Deleted Message from ${selectedGroupData?.name}`);
    } catch (error) {
      console.log('error: ', error);
    }
  }

  //prevent chat leaks to other groups
  if (parseFloat(chat?.group_id) !== parseFloat(currentGroupChat?.id))  return

  return (
    <Stack
      display={isDeleted && "none"}
      position={"relative"}
      ref={ref}
      direction={chat?.sender?.id === authUserId ? "row-reverse" : "row"}
      alignItems="flex-start"
      alignSelf={chat?.sender?.id === authUserId ? "flex-end" : "flex-start"}
      className="chat-feed"
    >
      <Stack alignItems={"flex-start"}>
        {chat?.message !== "null" ? (
          <Text
            whiteSpace="pre-wrap"
            p="5px 8px"
            fontSize={["1.4em", ".8em", ".8em", ".8em"]}
            maxW="300px"
            {...(chat?.sender?.id === authUserId ? fromUserStyle : toUserStyle)}
          >
            <Text color={authUserId === chat?.sender?.id ? "green" : "orange"}>
              {" "}
              {authUserId === chat?.sender?.id ? "You" : chat?.sender?.username}
            </Text>
            
            {checkSTring(chat?.message)}
          </Text>
        ) : (
          <Fancybox
            options={{
              Carousel: {
                infinite: false,
              },
            }}
          >
            <a data-fancybox="gallery" href={chat?.file}>
            {/* {progressBar && progressBar?.groupId == currentGroupChat?.id && authUserId === chat?.sender?.id && 
              <Progress hasStripe
              value={progressBar}
              aria-valuenow={progressBar}  
            />} */}
            <Image
              src={chat?.file}
              maxW="150px"
              maxH="150px"
              borderRadius={"5px"}
              objectFit={"contain"}
              onLoad={() => setIsServerImageLoaded(true)} // Set the flag when the server image is loaded
            />

            </a>
            {/* Display the "Loading..." indicator if the server image is not yet loaded */}
            {!isServerImageLoaded &&
              <Spinner thickness="2px" speed="0.65s" color="#E54242" size="sm" />
            }
          </Fancybox>
          
        )}
        <Text fontSize={[".9em", ".7em", ".7em", ".7em"]} color="#AFBBC6">
          {convertToTimeAgo(chat?.created_at)}
        </Text>

      </Stack>
        { chat?.sender?.id === authUserId ? (
        
        <Popover
          closeOnBlur={true}
          placement='top'
        >
          <PopoverTrigger>
          <Box
            className="caret-box"
            position={"absolute"}
            top={"0"}
            right={"0"}
            fontSize={"1.5em"}
          >
            <IoCaretDownOutline/>
          </Box>
          </PopoverTrigger>
          <PopoverContent color='white' bg='#07182E' border='0' width={"100%"}>
            <PopoverArrow />
            <PopoverBody border='0'>
              {/* Add your popover content here, e.g., a menu */}
              <Stack
                  display='block'
                  alignItems='center'
                  justifyContent='space-between'
              >
          
                <Box fontSize='sm' textAlign={'center'} color={'red'} cursor={'pointer'}
                  onClick={() => setDeleteGroupMessageModalOpen(true)}
                >Delete Message</Box>
              </Stack>
              
            </PopoverBody>
          </PopoverContent>
        </Popover>

        ) : (
        
          <Popover
          closeOnBlur={true}
          placement='right'
          >
          <PopoverTrigger>
          <Box
            className="caret-box"
            position={"absolute"}
            top={"0"}
            right={"1"}
            fontSize={"1.5em"}
          >
          <IoCaretDownOutline/>
          </Box>
          </PopoverTrigger>
          <PopoverContent color='white' bg='#07182E' border='0' width={"100%"}>
            <PopoverArrow />
            <PopoverBody border='0'>
              {/* Add your popover content here, e.g., a menu */}
              <Stack
                display='block'
                alignItems='center'
                justifyContent='space-between'
              >

                <Box fontSize='sm' textAlign={'center'} color={'red'} cursor={'pointer'}
                  onClick={() => setDeleteGroupMessageModalOpen(true)}
                >Delete Message</Box>
              </Stack>
              
            </PopoverBody>
          </PopoverContent>
          </Popover>
        )}

        <DeleteGroupMessageModal
          authUserId={authUserId} chat={chat} groupData={currentGroupChat} handleGroupMessageDelete={handleGroupMessageDelete}
          isOpen={deleteGroupMessageModalOpen} onClose={() => setDeleteGroupMessageModalOpen(false)} setIsDeleted={setIsDeleted} 
        />

    </Stack>
  );
};
